export default __webpack_public_path__ + "static/media/plant_watch_img.42395dc2.svg";